import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { memo as N, useCallback as C, useMemo as z } from "react";
import { clsx as r } from "../../../node_modules/clsx/dist/clsx.m.js";
import x from "../Icon/Icon.js";
import t from "./Tag.module.scss.js";
import { Avatar as S } from "../Avatars/Avatar.js";
import { Typography as d } from "../Typography/Typography.js";
const w = ({
  prefix: e = "none",
  tagCount: l,
  closeIcon: j,
  label: b = "Label",
  type: o = "stroke",
  maxWidth: n,
  onClick: a,
  onClose: i,
  iconProps: u,
  iconName: c,
  disabled: m = !1,
  active: g = !1,
  testId: v,
  avatarProps: f,
  closeIconTestId: T = "close-icon"
}) => {
  const p = r(t.tag, t[e], t[o], {
    [t.active]: a,
    [t.disabled]: m,
    [t.activeState]: g,
    [t.backgroundTag]: g
  }), y = C(
    (k) => {
      a && a(k);
    },
    [a]
  ), h = z(() => {
    if (e === "icon" && c)
      return /* @__PURE__ */ s.jsx(
        x,
        {
          name: c,
          ...u,
          size: "sm"
        }
      );
    if (e === "avatar")
      return /* @__PURE__ */ s.jsx(
        S,
        {
          size: "xs",
          ...f
        }
      );
    if (e === "none")
      return null;
  }, [e, u, c, f]);
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: p,
      "data-testid": v,
      children: [
        /* @__PURE__ */ s.jsxs(
          "button",
          {
            className: r(t.tagButton, {
              [t.cursor]: a,
              "max-w-[calc(100%-20px)]": i
            }),
            onClick: y,
            disabled: m,
            type: "button",
            children: [
              h,
              /* @__PURE__ */ s.jsx(
                d,
                {
                  className: r(t.backgroundTag, !!n && "truncate"),
                  text: b,
                  variant: "interface/medium/sm",
                  ...!!n && { style: { maxWidth: n } }
                }
              ),
              Number(l) > 0 && /* @__PURE__ */ s.jsx(
                "div",
                {
                  className: r(
                    t.tagCount,
                    o === "stroke" ? t.strokeTagCount : t.grayTagCount
                  ),
                  children: /* @__PURE__ */ s.jsx(
                    d,
                    {
                      textColor: o === "gray" ? "color/fg/inverse" : "color/fg/light",
                      text: l,
                      variant: "interface/strong/sm"
                    }
                  )
                }
              )
            ]
          }
        ),
        j && /* @__PURE__ */ s.jsx(
          "button",
          {
            className: t.closeContainer,
            onClick: i,
            "data-testid": T,
            disabled: m,
            type: "button",
            children: /* @__PURE__ */ s.jsx(
              x,
              {
                name: "x-close",
                size: "sm",
                className: t.cursor
              }
            )
          }
        )
      ]
    }
  );
}, $ = N(w);
export {
  $ as default
};
//# sourceMappingURL=Tag.js.map
